import { render, staticRenderFns } from "./ConceptBooth.vue?vue&type=template&id=82b21884&scoped=true"
import script from "./ConceptBooth.vue?vue&type=script&lang=js"
export * from "./ConceptBooth.vue?vue&type=script&lang=js"
import style0 from "./ConceptBooth.vue?vue&type=style&index=0&id=82b21884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../ct-id-20261026/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b21884",
  null
  
)

export default component.exports